import { competetiveService } from "../../services";
import { ActionTypes } from "../constants/actionTypes";
import { alertError } from "./alertActions";


export const addNotification = (notification) => ({
    type: ActionTypes.ADD_NOTIFICATION,
    payload: notification
})

export const fetchNotifications = (access) => {
    return (dispatch) => {
        dispatch(request({}))
        competetiveService.getNotifications(access).then((notificaitons) => {
            dispatch(success(notificaitons));
        }).catch((err) => {
            console.error(err);
            dispatch(failure(err));
            dispatch(alertError(err));
        });
    }
    function request(user) {
        return { type: ActionTypes.FETCH_NOTIFICATION_REQUEST, user };
    }
    function success(payload) {
        return { type: ActionTypes.FETCH_NOTIFICATION_SUCCESS, payload };
    }
    function failure(error) {
        return { type: ActionTypes.FETCH_NOTIFICATION_FAILURE, error };
    }
}

export const markNotificationRead = (id, access) => {
    return (dispatch) => {
        dispatch(request({}))
        competetiveService.readNotification(access, id).then((notificaitons) => {
            dispatch(success(notificaitons));
        }).catch((err) => {
            console.error(err);
            dispatch(failure(err));
            dispatch(alertError(err));
        });
    }
    function request(user) {
        return { type: ActionTypes.MARK_NOTIFICATION_READ_REQUEST, user };
    }
    function success(payload) {
        return { type: ActionTypes.MARK_NOTIFICATION_READ_SUCCESS, payload, id };
    }
    function failure(error) {
        return { type: ActionTypes.MARK_NOTIFICATION_READ_FAILURE, error };
    }
}
export const cleanUnreadNotifications = (access) => {
    return (dispatch) => {
        dispatch(request({}))
        competetiveService.clearUnreadNotification(access).then((notificaitons) => {
            dispatch(success(notificaitons));
        }).catch((err) => {
            console.error(err);
            dispatch(failure(err));
            dispatch(alertError(err));
        });
    }
    function request(user) {
        return { type: ActionTypes.CLEAR_UNREAD_REQUEST, user };
    }
    function success(payload) {
        return { type: ActionTypes.CLEAR_UNREAD_SUCCESS, payload };
    }
    function failure(error) {
        return { type: ActionTypes.CLEAR_UNREAD_FAILURE, error };
    }
}

export const checkUserCompetitorFollow = (access, id) => {
    return (dispatch) => {
        dispatch(request({}))
        competetiveService.checkCompetitorFollow(access, id).then((payload) => {
            dispatch(success(payload));
        }).catch((err) => {
            console.error(err);
            dispatch(failure(err));
            dispatch(alertError(err));
        });
    }
    function request(user) {
        return { type: ActionTypes.COMP_CHECK_REQUEST, user };
    }
    function success(payload) {
        return { type: ActionTypes.COMP_CHECK_SUCCESS, payload };
    }
    function failure(error) {
        return { type: ActionTypes.COMP_CHECK_FAILURE, error };
    }
}

export const userCompetitorFollowUnfollow = (access, prevState, id) => {
    return (dispatch) => {
        dispatch(request({}))
        let body = { 'competitor_id': id }
        if (prevState) {
            competetiveService.unfollowCompetitor(access, JSON.stringify(body)).then((payload) => {
                dispatch(success(payload));
            }).catch((err) => {
                console.error(err);
                dispatch(failure(err));
                dispatch(alertError(err));
            });
        } else {
            competetiveService.followCompetitor(access, JSON.stringify(body)).then((payload) => {
                dispatch(success(payload));
            }).catch((err) => {
                console.error(err);
                dispatch(failure(err));
                dispatch(alertError(err));
            });
        }
    }
    function request(user) {
        if (prevState) {
            return { type: ActionTypes.UNFOLLOW_COMPETITOR_REQUEST, user };
        } else {
            return { type: ActionTypes.FOLLOW_COMPETITOR_REQUEST, user };
        }
    }
    function success(payload) {
        if (prevState) {
            return { type: ActionTypes.UNFOLLOW_COMPETITOR_SUCCESS, payload };
        } else {
            return { type: ActionTypes.FOLLOW_COMPETITOR_SUCCESS, payload };
        }
    }
    function failure(error) {
        if (prevState) {
            return { type: ActionTypes.UNFOLLOW_COMPETITOR_FAILURE, error };
        } else {
            return { type: ActionTypes.FOLLOW_COMPETITOR_FAILURE, error };
        }
    }
}
